import form from "./schemas/form";
import validations from "./schemas/validations";
import initialValues from "./schemas/initialValues";
import {useState} from "react";
import axios from "axios";
import {API_URL} from "../../../config";
import {storeLocationService} from "../../../services/locationService";

const useNewLocation = () => {

    const {formId, formField} = form;

    const [isLoading, setIsLoading] = useState(false);

    const [snackbarConfig, setSnackbarConfig] = useState({
        color: 'success',
        title: '',
        message: '',
        icon: 'notifications'
    });
    const [show, setShow] = useState(false);
    const toggleSnackbar = () => setShow(!show);

    const handleSubmit = async (values, actions) => {

        try {

            // Enviar datos a API
            await storeLocationService(values);

            actions.resetForm();

            setSnackbarConfig({
                message: 'Sucursal registrada exitosamente',
                icon: 'notifications',
                title: 'Sucursales',
                color: 'success'
            });

            setShow(true);

        } catch (error) {

            setSnackbarConfig({
                message: error.response.data.message,
                icon: 'cancel',
                title: 'Sucursales',
                color: 'warning'
            });

            setShow(true);

        }

        actions.setSubmitting(false);

    };

    return {
        validations,
        formId,
        formField,
        isLoading,
        show,
        initialValues,
        snackbarConfig,
        handleSubmit,
        toggleSnackbar
    };
};

export default useNewLocation;
